<template>
  <div class="media_detail_container" ref="media_detail">
    <div class="media_info_box" v-if="!!mediaInfo">
      <div class="media_info">
        <div class="media_portrait">
          <div class="portrait">
            <img :src="mediaInfo.lconImagePath" />
          </div>
          <div class="text">
            <div class="nick">
              <span v-text="mediaInfo.name"></span>
            </div>
            <div class="label">
              <span class="media_type" v-if="mediaInfo.isReporterFreChannel">记者号</span>
              <span class="media_type" v-else>极目+</span>
            </div>
            <div class="num">
              <span>发布 <span v-text="mediaInfo.pubContentsCount"></span></span>
              <span>关注 <span v-text="mediaInfo.subscribeNum"></span></span>
            </div>
            <span class="attention" @click="onAttentionClick($event)" v-text="attentionStr">+ 关注</span>
          </div>
        </div>
        <div class="media_intro">
          <pre v-html="mediaInfo.introduce"></pre>
        </div>
      </div>
      <div class="media_category">
        <van-tabs :class="{'media_category_tabs':true,'message':params.contentCate==6}" @click="onTabClick" v-model="selectedIndex" swipe-threshold="2" sticky :offset-top=offsetTop>
          <van-tab v-for="item in tabList" :title="item.name" :key="item.id">
            <div class="cate_content_list">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="media_news_list" :disabled="refDisabled">
                <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
                  <messages-List v-if="selectedIndex== 3" :contentList="contentList" @deleteItem="deleteSelfMediaMessagesItem"></messages-List>
                  <news-list v-else :contentList="contentList" :deviceId="deviceId"></news-list>
                </van-list>
              </van-pull-refresh>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="new_msg_box" v-if="selectedIndex==3">
      <span class="new_msg" @click="toAddMessage"></span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getRandomStr32, loadStat, addScore,addH5Escalate } from "@/utils";
import mediaApi from "@/api/apis/media.js";
import commApi from "@/api/apis/common.js";
import NewsList from "./components/MediaNewsList";
import MessagesList from "./components/MediaMessagesList";
export default {
  name: "MediaDetail",
  components: {
    NewsList,
    MessagesList
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  watch: {
    scrollTop(val) {
      if (val == 0) {
        this.refDisabled = false
      } else {
        this.refDisabled = true
      }
    }
  },
  data() {
    return {
      refDisabled: false, //下拉刷新是否禁用
      scrollTop: 0,
      /* 设备Id */
      deviceId: null,
      offsetTop: 0,
      mediaParams: {
        contentType: null,
        id: null,
      },
      mediaInfo: null, //媒体号信息/媒体号信息
      attentionStr: "+ 关注",
      subscribed: false,
      categoryList: [], //媒体号文章分类
      tabList: [
        {
          id: -1,
          name: '全部'
        }, {
          id: 0,
          name: '文章'
        }, {
          id: 1,
          name: '视频类型'
        }, {
          id: 6,
          name: '留言'
        },
      ],  //tab标签 媒体号稿件分类 -1全部(默认)，0文章(非视频类型)1视频类型  6留言为自定义需要单独判断
      selectedIndex: 0,
      refreshing: false,
      loading: false,
      finished: false,
      messagesParams: {  //留言接口参数
        frechannelId: null,
        memberId: null,
        pageNo: 0,
        pageSize: 20
      },
      params: {
        pageNo: 0,
        pageSize: 20,
        frechannelId: null,
        contentCate: -1
      },
      contentList: [], //媒体号文章分类下的文章列表
      contentTotal: 0, //总数
      contentPageCount: 0, //总页数
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
      shareUrl: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/media_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;
      var desc = _this.mediaInfo.summaryStatus ? _this.mediaInfo.summarySth : _this.mediaInfo.introduce;
      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.mediaInfo.name, desc, _this.shareUrl, _this.mediaInfo.lconImagePath);
        this.$emit('initWeiXinTicket');
      }).catch((err) => {

      })
    },
    /* 切换分类 */
    onTabClick(index) {
      var _this = this;
      _this.selectedIndex = index;
      _this.params.contentCate = _this.tabList[index].id;
      _this.contentList = [];
      _this.contentTotal = 0;
      _this.contentPageCount = 0;
      _this.loadFirstPage = true;
      if (_this.finished) {
        _this.refreshing = false;
      } else {
        _this.refreshing = true;
      }
      _this.loading = false;
      _this.finished = false;
      if (_this.selectedIndex == 3) { //留言
        _this.messagesParams.pageNo = 0
        _this.getListSelfMediaMessages();
      } else {
        _this.params.pageNo = 0;
        _this.getContentListByCateId(); // 根据分类Id获取稿件列表
      }
    },
    // 获取媒体号信息
    getMediaInfo() {
      var _this = this;
      mediaApi
        .getSelfMediaById(_this.mediaParams)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.name;
            _this.mediaInfo = res.data;
            // 中宣部埋点：首页页面浏览（自媒体）
            _this.$track.trackPageViewOnce(
              _this.$track.EVENT_CODE.HOME_PG,
              _this.$track.mapArticleProps(_this.mediaInfo, {
                pageName: "自媒体详情页",
                pageId: "media_detail",
                extra: { article_type: "自媒体" },
              })
            );
            addH5Escalate();
            _this.wechatShare(); // 微信二次分享
            _this.params.frechannelId = res.data.id;
            _this.messagesParams.frechannelId = res.data.id;
            _this.getContentListByCateId(); // 根据分类Id获取稿件列表
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    // 获取留言列表
    getListSelfMediaMessages() {
      var _this = this;
      _this.messagesParams.nodeCode = _this.nodeCode;
      if (!!this.userInfo) {
        _this.messagesParams.memberId = _this.userInfo.id;
      }
      mediaApi
        .listSelfMediaMessages(_this.messagesParams)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.messagesParams.pageNo == 0) {
              _this.contentList = res.data.list;
            } else {
              _this.contentList = _this.contentList.concat(res.data.list);
            }
            _this.contentTotal = res.data.total;
            _this.contentPageCount = Math.ceil(
              res.data.total / _this.messagesParams.pageSize
            );
            if (_this.messagesParams.pageNo >= _this.contentPageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;

          } else {
            _this.finished = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    // 删除留言
    deleteSelfMediaMessagesItem(i) {
      this.contentList.splice(i, 1);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "dy", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
        description: "订阅", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
        // contentType: this.mediaParams.contentType, // 非必传，稿件的type
        // contentId: this.mediaParams.id, // 非必传，稿件的id
        // contentName: this.mediaInfo.name, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    // 根据分类Id获取稿件列表
    getContentListByCateId() {
      var _this = this;
      mediaApi
        .findContentPageByFreChannelId(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.contentList = res.data.list;
            } else {
              _this.contentList = _this.contentList.concat(res.data.list);
            }
            _this.contentTotal = res.data.total;
            _this.contentPageCount = Math.ceil(
              res.data.total / _this.params.pageSize
            );
            if (_this.params.pageNo >= _this.contentPageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            _this.finished = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.contentTotal = 0;
      this.contentPageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      if (this.selectedIndex == 3) {
        this.messagesParams.pageNo = 0;
        this.getListSelfMediaMessages();
      } else {
        this.params.pageNo = 0;
        this.getContentListByCateId(); //根据分类Id获取稿件列表
      }
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        if (this.selectedIndex == 3) {
          this.messagesParams.pageNo++;
          if (this.messagesParams.pageNo < this.contentPageCount) {
            this.getListSelfMediaMessages();
          }
        } else {
          this.params.pageNo++;
          if (this.params.pageNo < this.contentPageCount) {
            this.getContentListByCateId();
          }
        }
      }
    },
    /* 获取订阅信息 */
    getSubscription() {
      var _this = this;
      var params = {
        id: _this.mediaParams.id,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .isSubscribe(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已关注";
          } else {
            _this.subscribed = false;
            _this.attentionStr = "+ 关注";
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 关注 */
    subscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.mediaParams.id,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .subscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已关注";
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消关注 */
    unSubscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.mediaParams.id,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .unSubscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = false;
            _this.attentionStr = "+ 关注";
            _this.$toast({
              message: "取消关注成功",
              position: "center",
            });
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 关注/取消关注 */
    onAttentionClick(event) {
      if (!!this.userInfo) {
        /* 已关注则取消关注 */
        if (this.subscribed) {
          this.unSubscribeSelfMedia(); // 取消关注
        } else {
          this.subscribeSelfMedia(); // 关注
        }
      } else {
        this.$router.push("/login");
      }
    },
    /*  */
    /* 跳转新增报料 */
    toAddMessage() {
      if (!!this.userInfo) {
        this.$router.push({
          path: "/new_message",
          query: { freChannelId: this.mediaParams.id },
        });
        return;
      } else {
        this.$router.push("/login");
        return;
      }
    }
  },
  mounted() {
    let _this = this;
    // 设置粘性布局高度
    _this.offsetTop = document.getElementsByClassName('top_header')[0].offsetHeight;
    window.onresize = function () {
      _this.offsetTop = document.getElementsByClassName('top_header')[0].offsetHeight;
    }
    // 下拉刷新判断
    let box = this.$refs.media_detail;
    box.addEventListener('scroll', () => {
      this.scrollTop = box.scrollTop;
    });
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "id")) {
      this.mediaParams.contentType = query.contentType;
      this.mediaParams.id = Number(query.id);
      this.getMediaInfo(); //获取自媒体信息
      if (!!this.userInfo) {
        this.getSubscription(); //获取订阅信息
      } else {
        this.deviceId = getRandomStr32();
      }
      loadStat(); // 友盟统计
    } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.mediaParams.contentType = query.contentType;
      this.mediaParams.id = Number(query.contentId);
      this.getMediaInfo(); //获取自媒体信息
      if (!!this.userInfo) {
        this.getSubscription(); //获取订阅信息
      } else {
        this.deviceId = getRandomStr32();
      }
      loadStat(); // 友盟统计
    }
  },
};
</script>
<style scoped lang="scss">
.media_detail_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .media_info_box {
    background: url(~@/assets/images/tj_media_top_bg.jpg) no-repeat center top;
    background-size: 100% auto;
    .media_info {
      padding: 12px 14px;
      overflow: hidden;
      color: #fdfffc;
      font-size: 13px;
      .media_portrait {
        display: flex;
        align-items: center;
        .portrait {
          width: 60px;
          height: 60px;
          line-height: 60px;
          margin-right: 15px;
          overflow: hidden;
          background-image: url(~@/assets/images/user_default.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          border: 1px solid #fff;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          img {
            object-fit: cover;
            min-width: 100%;
            min-height: 100%;
          }
        }
        .text {
          position: relative;
          width: 100%;
          overflow: hidden;
          flex: 1;
          .nick {
            color: #fdfffc;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 28px;
            font-size: 16px;
          }
          .label {
            margin-bottom: 5px;
            .media_type {
              padding: 1px 6px;
              border: 1px solid #fff;
              font-size: 12px;
              border-radius: 9px;
            }
          }
          .num {
            font-size: 12px;
            span {
              margin-right: 10px;
            }
          }
          .attention {
            position: absolute;
            right: 0;
            top: 21px;
            padding: 2px 10px;
            background: #fff;
            border-radius: 7px;
            color: #b2171b;
            font-size: 12px;
          }
        }
      }
      .media_intro {
        margin-top: 10px;
        pre {
          line-height: 24px;
          white-space: break-spaces;
          font-size: 14px;
        }
      }
    }
    .media_category {
      .media_category_tabs {
        background-color: #fff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        overflow: hidden;
        &.message {
          background-color: #f1f1f1;
        }
        /deep/.van-sticky {
          box-shadow: 0px 5px 5px #ddd;
        }
        .cate_content_list {
          position: relative;
          width: 100%;
          height: auto;
          .media_news_list {
            padding: 0 15px;
          }
        }
      }
    }
  }
  .new_msg_box {
    position: fixed;
    right: 0;
    bottom: 10%;
    z-index: 10;
    width: 30%;
    height: 0;
    padding-bottom: 13.5%;
    .new_msg {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      width: 100%;
      height: 100%;
      background: url(~@/assets/images/new_message.png) no-repeat center center;
      background-size: 100% auto;
    }
  }
}
</style>